// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kHGZy","toggle":"styles_toggle__1w0Yo","preview":"styles_preview__38wck"};